module.exports = __webpack_public_path__ + "next.ae4f4880.png";